export const initialCommonState = {
  alertArr: [],
  ustate: "initial state"
};

export const commonReducer = (state, action) => {
  switch (action.type) {
    case "ADD_ALERT":
      return {
        ...state,
        alertArr: [...state.alertArr,action.payload]
      };
    case "REMOVE_ALERT":
      return {
        ...state,
        alertArr: state.alertArr.slice(1),
      };
    default:
      return state;
  }
};